import { Page } from 'components/layout';
import { Box, Button, Message } from 'components/ui';
import { useWallet } from '../WalletContext';
import EBCollectionList from '../EBCollectionList';
import { REQUEST_STATUS } from '../../constants';
import ItemListLoading from 'components/ItemListLoading';
import { useInfiniteOwnedEulerBeatsNfts } from 'hooks/useOwnedEulerBeatsNfts';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useMemo } from 'react';
import flatten from 'lodash/flatten';

const Collection = ({ address }: { address: string }) => {
  const { data, fetchNextPage, hasNextPage, status } = useInfiniteOwnedEulerBeatsNfts(address);

  const displayNfts = useMemo(() => {
    const allNfts = flatten((data?.pages ?? []).map(page => page.results));
    return allNfts;
  }, [data?.pages]);

  return (
    <>
      {status === REQUEST_STATUS.loading && (
        <Box width="100%" textAlign="center">
          <ItemListLoading />
        </Box>
      )}

      {status === REQUEST_STATUS.success && (
        <InfiniteScroll
          height="calc(100vh - 180px)"
          dataLength={displayNfts.length}
          next={fetchNextPage}
          hasMore={Boolean(hasNextPage)}
          loader={
            <Box width="100%" textAlign="center">
              <ItemListLoading />
            </Box>
          }
        >
          <EBCollectionList owned={displayNfts} />
        </InfiniteScroll>
      )}

      {status === REQUEST_STATUS.error && <Message color="black">Error loading items.</Message>}
    </>
  );
};

const MyEBCollection = () => {
  const { address, selectWallet } = useWallet();

  return (
    <Page
      title="My EB Collection"
      showTitle
      padding={['0 8px', '0 24px']}
      fixedFooter={false}
      background="#333"
    >
      <Box maxWidth="1400px" margin="0 auto">
        {!address && (
          <Button onClick={selectWallet} margin="8px auto">
            Connect Wallet
          </Button>
        )}
      </Box>

      {address && <Collection address={address} />}
    </Page>
  );
};

export default MyEBCollection;
